import React from "react";
import { ListGroup } from "react-bootstrap";
import { useContacts } from "../contexts/ContactsProvider";
import { DOMAIN } from "../utils";

import avatar from "../../assets/img/default-avatar.png";
export default function Contacts() {
  const { contacts } = useContacts();

  return (
    <ListGroup variant="flush" style={{ padding: "10px 0" }}>
      {contacts.map((contact) => (
        <ListGroup.Item
          key={contact.id}
          style={{
            border: "none",
            borderBottom: "1px solid #f0f0f0",
            padding: "15px 20px",
            cursor: "pointer",
            transition: "all 0.2s ease",
            backgroundColor: "#ffffff",
            borderRadius: "0",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#f8f9fa";
            e.currentTarget.style.paddingLeft = "25px";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#ffffff";
            e.currentTarget.style.paddingLeft = "20px";
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <div style={{ position: "relative", marginRight: 12 }}>
              <img
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #e9ecef",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  display: "block",
                }}
                src={
                  contact.profile && contact.profile !== "-"
                    ? DOMAIN + contact.profile
                    : avatar
                }
                alt={contact.name}
                onError={(e) => {
                  e.target.src = avatar;
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  width: 16,
                  height: 16,
                  borderRadius: 8,
                  backgroundColor: "#28a745",
                  border: "2px solid white",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }}
              />
            </div>
            <span
              style={{
                whiteSpace: "nowrap",
                fontWeight: 500,
                fontSize: "15px",
                color: "#2c3e50",
              }}
            >
              {contact.name}
            </span>
          </div>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
}
